import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { ProviderSettings } from '@shipstation/connections-ui';
import { DirectCarrierSettings } from '@shipstation/connections-ui/direct';

import { noop } from 'ui-components/default-props/noop';

import { useCuiApiConfig } from './helpers/use-cui-api-config';
import { useCuiContextProps } from './helpers/use-cui-context-props';
import { useEnableDirectModeCarriers } from '../feature-flags/hooks/use-enable-direct-mode-carriers';
import { useCommonCuiProps } from './helpers/use-common-cui-props';

const defaultSellerData = { shipFroms: [] };

export const CuiProviderSettings = ({
  providerType,
  providerApiCode,
  accountId,
  onSave = noop,
  onCancel = noop,
  onError = noop,
  onUpdateSellerData = noop,
  sellerData = defaultSellerData,
}) => {
  const isDirectMode = useEnableDirectModeCarriers();
  const commonCuiProps = useCommonCuiProps();
  const cuiApiConfig = useCuiApiConfig();
  const cuiContextProps = useCuiContextProps();

  const directContextProps = useMemo(
    () => ({
      ...cuiContextProps,
      onCancel,
      onError,
      onSave,
      onUpdateSellerData,
      sellerData,
    }),
    [cuiContextProps, onCancel, onError, onSave, onUpdateSellerData, sellerData],
  );

  if (isDirectMode) {
    return (
      <DirectCarrierSettings
        accountId={accountId}
        apiConfig={cuiApiConfig}
        contextProps={directContextProps}
        providerApiCode={providerApiCode}
        providerType={providerType}
      />
    );
  }

  return (
    <ProviderSettings
      {...commonCuiProps}
      accountId={accountId}
      onCancel={onCancel}
      onError={onError}
      onSave={onSave}
      onUpdateSellerData={onUpdateSellerData}
      providerApiCode={providerApiCode}
      providerType={providerType}
      sellerData={sellerData}
    />
  );
};

CuiProviderSettings.propTypes = {
  providerApiCode: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  providerType: PropTypes.string.isRequired,
  onError: PropTypes.func,
  onSave: PropTypes.func,
  onUpdateSellerData: PropTypes.func,
  onCancel: PropTypes.func,
  sellerData: PropTypes.shape({ shipFroms: PropTypes.array }),
};
